import styled from 'styled-components';
import { largeLayout } from '@styles/layout';

export const SectionTeaserWrapper = styled.section`
`;

export const TeaserVideoWrapper = styled.div`
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 60px;
  width: 600px;
`;

export const SectionTeaserTextWrapper = styled.div`
  text-align: center;
  max-width: ${largeLayout.getSize(8)}px;
  margin: 0 auto;
`;


// WEBPACK FOOTER //
// src/app/src/components/SectionTeaser/SectionTeaser.s.ts